var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFj(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M473.655,88.276H38.345C17.167,88.276,0,105.443,0,126.621V385.38 c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345V126.621 C512,105.443,494.833,88.276,473.655,88.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M8.828,256h238.345c4.875,0,8.828-3.953,8.828-8.828V97.103c0-4.875-3.953-8.828-8.828-8.828H38.345 C17.167,88.276,0,105.443,0,126.621v120.552C0,252.047,3.953,256,8.828,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M247.172,88.276h-15.334l-81.77,53.574V88.276H105.93v53.574L24.16,88.276H8.828 C3.953,88.276,0,92.228,0,97.103v7.002l70.155,45.963H0v44.138h70.155L0,240.17v7.002C0,252.047,3.953,256,8.828,256h15.334 l81.77-53.574V256h44.138v-53.574L231.839,256h15.334c4.875,0,8.828-3.953,8.828-8.828v-7.002l-70.155-45.963H256v-44.138h-70.155 L256,104.106v-7.002C256,92.228,252.047,88.276,247.172,88.276z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,158.897 141.241,158.897 141.241,88.276 114.759,88.276 114.759,158.897 0,158.897  0,185.379 114.759,185.379 114.759,256 141.241,256 141.241,185.379 256,185.379  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M8.227,102.902l72.662,47.167h16.214l-82.496-53.55C12.238,98.389,10.097,100.532,8.227,102.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M166.283,150.069l88.374-57.366c-1.536-2.599-4.246-4.427-7.485-4.427h-1.909l-95.194,61.793 H166.283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M89.474,194.207L1.269,251.463C2.79,254.125,5.542,256,8.828,256h1.665l95.196-61.793H89.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M255.86,247.865l-82.666-53.658H156.98l93.874,60.935 C253.666,253.837,255.595,251.102,255.86,247.865z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M322.034,184.617v96.858c0,39.281,55.178,59.469,61.902,61.782 c6.717-2.313,61.902-22.534,61.902-61.782v-96.858H322.034L322.034,184.617z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "448.022,229.041 448.022,182.432 319.849,182.432 319.849,229.041 375.197,229.041  375.197,272.736 319.849,272.736 319.849,290.215 375.197,290.215 375.197,342.648 383.936,345.561 392.674,342.648  392.674,290.215 448.022,290.215 448.022,272.736 392.674,272.736 392.674,229.041 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 334.22,
    cy: 210.86,
    r: 7.293
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M348.231,200.999c-2.334-1.283-6.535-4.726-8.226-4.142c-1.692,0.584-2.07,1.78-4.437,1.962 c-2.306,0.178-5.948,2.428-4.43,4.922c1.973,3.246,8.149,0.722,8.557-0.796c0,0,1.517,0.243,2.792-0.061 c0,0,2.537,3.54,5.687,3.307c3.15-0.234,4.609-4.142,3.91-4.142S348.231,200.999,348.231,200.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M357.916,216.459c-0.525,0.962-4.522,4.38-11.202,5.951c-1.487,0.35-1.225,2.1-2.713,1.225 c-1.487-0.875-5.601-1.576-9.277-1.75c-3.676-0.175-4.041-3.581-3.413-4.813c0.797-1.565,6.665-2.519,7.715-0.594 c1.05,1.926,1.837,1.524,4.45,2.081c1.619,0.346,1.663,1.138,1.663,1.138s2.976-2.976,5.514-3.851s4.726-2.801,5.163-2.801 c0.438,0,2.713,0.612,2.713,0.612L357.916,216.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M367.63,206.132c3.851,1.4,15.228,0.962,27.392-2.976s15.666-4.638,21.617-2.451 s8.527-4.725,4.619-5.894c-6.138-1.837-25.124,9.194-38.871,3.004c0,0-0.405,1.665,0.032,2.452c0,0-9.976,0.35-7.614-9.976 c0,0,0.68,3.77,5.397,3.337c8.921-0.819,10.196,5.462,29.085-0.362c10.487-3.233,18.635-1.646,18.707,3.456 c0.087,6.143-8.381,7.571-8.381,7.571s3.296,6.739,9.948,3.763s7.001,2.158,7.585,3.91c0.584,1.751,1.692,3.443,3.15,3.617 c0,0,1.05,3.15,0.642,3.559c-0.408,0.408-3.15,3.851-5.892,3.851s-8.693,0-8.693,0s-1.576-3.91,1.459-3.967 c3.033-0.058,6.71-0.291,6.243-1.926c-0.467-1.633-2.859-2.392-2.801-4.201c0,0-7.06,5.134-11.435-0.934l-0.117,2.859 c0,0-5.31-0.992-7.234-5.251c0,0,0.525,4.785-4.025,4.084c0,0,0.934,1.4,2.509,2.392c1.576,0.992-0.059,3.15-3.092,4.959 c-3.033,1.809-12.369,7.06-16.628,1.692c-4.259-5.367,0.934-8.46,2.217-8.11s4.959,6.009,7.468,5.251 c2.509-0.758,3.734-3.326,1.633-4.9s-3.673-3.064-2.349-4.654c1.821-2.185,8.534-1.53,8.3-2.988 c-0.233-1.459-6.476-1.05-10.56,3.033c-4.084,4.084-21.821,13.478-28.881,7.527C362.001,211.908,367.63,206.132,367.63,206.132z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD25A"
    },
    d: "M365.355,203.507c0,0,5.338,5.251,14.353,6.914c0,0-1.663,2.538-6.476,1.838 c0,0,1.926,1.663,3.239,4.463c0,0-3.063,0.7-5.777-0.788c0,0,0.35,2.275,1.663,4.114c0,0-3.588,0-6.652-2.713l-1.225,3.5 c0,0-2.1-1.4-3.413-4.114c0,0-2.451,1.926-4.9,1.926c0,0,0.875-2.625,0.875-4.114c0,0-3.5,2.1-6.389,1.313 c0,0,0.087-3.676,1.05-4.726c0,0-2.275,0.263-3.763-0.525c0,0,0.875-2.013,1.313-3.326c0,0-2.451,0.087-3.938-1.313 c0,0,4.726-1.838,5.777-3.588L365.355,203.507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M356.749,188.804c1.05,0.584,2.742,1.867,3.443,4.025c0,0,1.926-2.801,5.251-3.326 c0,0,1.459,1.633,1.05,5.892c0,0,3.676-1.05,5.66,0.875c0,0-3.91,0.875-5.718,4.142c0,0-0.702,3.338,0.524,5.322 c0,0-1.365,0.182-2.741-0.42c0,0-0.7,3.326,0,4.376c0,0-1.926-0.234-2.976-2.275c0,0-1.576,2.392-1.459,3.851 c0,0-2.1-1.225-2.217-3.033c0,0-1.459,2.742-3.033,2.976c0,0-0.175-3.851-0.875-5.31c0,0-1.342,1.459-3.092,1.4 c0,0,0-2.976,1.459-4.376c0,0-2.451,0.758-3.793-1.926c0,0,4.025,1.166,5.017-1.283c0.992-2.451,1.283-3.209,2.684-4.551 C357.333,193.822,356.749,188.804,356.749,188.804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M365.355,200.094c0,0-4.989,9.539-9.539,6.652c-4.985-3.165,1.225-10.59,2.013-11.377 C357.828,195.368,361.504,196.331,365.355,200.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M347.363,248.952c0,0-0.523-6.851-4.237-8.828c-3.492-1.858-5.555-2.787-5.955-5.169 c0,0,3.034,1.394,6.241,2.265c2.898,0.787,5.726,5.692,4.867,11.209L347.363,248.952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B46446"
    },
    d: "M335.639,254.585l0.472,0.871l0.343,1.873l-0.687,2.221c0,0,2.729,1.085,3.35,4.791 c0.426,2.543,1.546,3.093,2.233,2.57s1.103-1.141,0.386-3.921c-0.916-3.549-3.393-6.925-3.393-6.925l-1.932-2.962L335.639,254.585z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M338.345,256.066c-2.49-3.223-9.277-9.931-10.564-0.785c0,0-2.66-7.706,2.319-7.405 C335.854,248.226,338.345,256.066,338.345,256.066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M336.111,255.457c-2.147-2.353-2.835-4.095-3.951-8.45c-1.117-4.355-1.46-5.663-2.749-5.576 c-1.289,0.087-2.061,1.481-2.061,4.268c0,0-3.779-3.398-1.203-6.098c2.577-2.7,8.331-1.219,8.675,3.572 c0.343,4.791,0.258,8.014,1.975,12.022L336.111,255.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M336.713,253.366c0,0-4.552-10.018,8.246-15.42c0,0-11.338-3.049-9.963,13.067L336.713,253.366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M338.174,256.938c0,0-9.62-3.659-8.761,5.227c0,0,1.632-4.182,6.356-2.613L338.174,256.938z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B46446"
    },
    d: "M349.081,253.423c0,2.599,1.022,10.14-0.429,11.093c-0.73,0.479-2.792,0.087-2.62-1.742 s0.988-10.716,0.988-12.893C347.02,247.703,349.081,253.423,349.081,253.423z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M342.955,259.464c1.661-1.684,2.176-5.517,1.603-10.628c0,0,3.436,2.381,4.524,4.588 c0,0,1.088-5.053-2.462-6.389c-3.55-1.336-5.44-0.58-6.07,1.045c-0.63,1.626,1.085,3.445,1.833,6.098 C343.069,256.618,342.955,259.464,342.955,259.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M348.853,252.088c0,0,0.573-2.671,2.462-3.775c0,0,3.894,2.73,3.607,6.389 c0,0,1.031-4.994-1.088-6.969c-2.119-1.974-4.524-2.497-5.726-0.755C346.905,248.719,348.853,252.088,348.853,252.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M349.769,246.977c0,0,1.203-7.144,4.237-8.712c3.034-1.568,8.647-3.02,8.99-3.369 c0,0-6.699,0.349-7.787,0.349c-1.088,0-7.101,4.355-7.101,10.803c0,6.446,0.573,2.033,0.745,1.974 C349.024,247.965,349.769,246.977,349.769,246.977z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B46446"
    },
    d: "M352.561,265.867c0.687,1.438,2.319,1.785,2.663,1.045c0.343-0.74,1.889-6.403,1.889-6.403 l-2.19-1.045L352.561,265.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M365.401,242.099c2.691-1.568,4.467,3.079,4.467,3.079c0-5.471-1.718-7.201-6.013-5.111 c-1.293,0.63-2.24,1.949-2.936,3.479c-2.174-6.247-6.969-6.151-6.969-6.151l-1.088,0.755c3.926,0.755,6.175,5.46,7.126,8.026 c-0.513,1.873-0.761,3.689-0.867,4.728c-2.573,2.667-4.198,8.559-4.198,8.559s1.847,1.089,2.19,1.045c0,0,1.203-3.702,2.706-3.615 s3.264,2.483,3.307,4.008c0,0,2.233-4.53-0.429-6.272c-1-0.654-1.8-0.903-2.446-0.915l1.974-2.221 c3.221,0.61,5.454,3.659,5.454,3.659c0.065-5.444-2.339-6.507-4.874-6.051C363.258,246.909,364.255,242.767,365.401,242.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B46446"
    },
    d: "M418.42,249.639c0,4.566,0,14.692,0,15.439s-3.27,3.652-3.27,3.652h8.693 c0,0-2.792-3.238-2.792-3.652s0.638-14.277,0.638-14.277L418.42,249.639z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M418.978,251.215c-2.073-0.166-7.816,4.566-9.491,11.787c0,0-5.105-8.301,7.657-15.191 c0,0-5.663-1.661-14.276,7.305c-0.465,0.484-0.877-13.53,14.595-9.795c0,0-5.902-8.551-18.025-1.826c0,0,8.055-14.444,19.939-1.494 c0,0,0.079-11.207,0.16-10.045s0.957,6.308,0.957,6.308l2.313-4.067l-1.834,8.301c0,0,10.607-14.112,19.62,0.582 c0,0-11.645-4.814-17.227,0.581c0,0,11.964-3.238,11.006,10.625c0,0-4.705-8.218-12.362-7.139c0,0,9.013,4.15,6.141,15.357 C428.15,262.505,422.719,251.514,418.978,251.215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M342.815,301.102c-0.444-0.601-1.066-0.89-1.676-0.966c0.235-0.81,0.392-1.18,0.329-1.77 c0.186,0.046,0.364,0.13,0.555,0.153l0.082-0.666c-0.708-0.085-1.48-0.403-2.273-0.887c0.489-0.419,0.843-1.063,0.843-1.852 c0-0.857-0.393-1.575-0.952-1.982c-0.558,0.408-0.952,1.126-0.952,1.982c0,0.643,0.264,1.159,0.61,1.572 c-0.295-0.204-0.593-0.44-0.892-0.694c-0.077-0.527-0.279-1.058-0.747-1.484c-0.633-0.577-1.428-0.77-2.106-0.632 c-0.075,0.687,0.191,1.461,0.824,2.039c0.489,0.446,1.065,0.598,1.618,0.61c0.126,0.107,0.258,0.214,0.397,0.323 c-0.38-0.046-0.789-0.007-1.198,0.142c-0.806,0.294-1.345,0.908-1.537,1.572c0.575,0.385,1.383,0.51,2.188,0.216 c0.703-0.256,1.155-0.771,1.399-1.335c0.471,0.301,0.988,0.552,1.523,0.753l-0.085,0.011c-0.018,0.483,0.014,0.682-0.226,1.58 c-0.541-0.351-1.257-0.509-2.014-0.286c-0.822,0.242-1.399,0.822-1.633,1.473c0.55,0.42,1.348,0.596,2.171,0.353 c0.618-0.182,1.037-0.579,1.336-1.03c-0.113,0.341-0.255,0.693-0.414,1.052c-0.483,0.223-0.936,0.567-1.213,1.137 c-0.375,0.77-0.335,1.588-0.011,2.199c0.681-0.122,1.348-0.596,1.724-1.366c0.289-0.595,0.274-1.19,0.128-1.724 c0.067-0.151,0.132-0.308,0.198-0.472c0.063,0.377,0.216,0.759,0.474,1.109c0.509,0.69,1.25,1.034,1.942,1.031 C343.433,302.603,343.324,301.792,342.815,301.102z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFECDE"
    },
    d: "M338.874,298.951c2.911,0,6.719-0.111,6.606,2.799c-0.111,2.911-3.359,12.766,4.143,15.789 s8.398,2.575,8.398,2.575l3.359,7.726l8.174-2.911l-7.839-6.271c0,0-0.672-4.255-2.575-7.167c0,0,4.815-2.464,6.495-4.591 l-3.359-0.224c0,0,4.367-2.799,6.382-5.934l-2.351,0.224c0,0,2.687-2.688,3.359-5.823c0,0-4.367,4.367-8.846,4.927 c0,0,1.903-4.927,2.351-6.83c0,0-3.359,2.127-5.71,3.023c-2.351,0.896-6.047,1.007-4.367,8.622c0,0-2.016-1.679-3.247-5.263 c-1.231-3.583-1.679-4.927-3.359-4.927c-2.743,0-3.807,2.464-3.807,2.464L338.874,298.951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B46446"
    },
    d: "M421.519,300.391c1.007-1.343,3.022-5.54,4.785-4.449s4.114,3.777,5.54,2.518 s1.511-2.854-0.672-3.609s-4.617-2.015-6.127-1.511c-1.511,0.503-6.127,5.289-6.127,5.289L421.519,300.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M408.509,304c-0.084-1.931,1.219-10.313,6.464-9.234c2.854,0.588,4.258,3.613,7.975,5.036 c3.945,1.511,6.464,2.434,5.708,5.036s-2.183,5.708-5.457,6.464C419.925,312.059,408.509,304,408.509,304z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M405.067,310.911c-1.119,0.224-5.26,6.268-0.335,12.424c0,0,6.044,2.462,10.857-1.343 s1.231-5.708,1.231-5.708L405.067,310.911z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M405.486,312.226c-0.503-0.756-0.419-1.315-0.419-1.315s-0.252-8.674,3.358-8.842 s16.62,8.394,16.62,9.821s-4.198,5.54-7.723,6.379C413.798,319.109,405.486,312.226,405.486,312.226z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B46446"
    },
    d: "M396.589,333.212c0,0,11.466-5.151,9.311-9.342c-1.555-3.023-5.05-1.086-5.603,1.223 C399.606,327.974,397.365,331.989,396.589,333.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M383.936,347.854l-0.663-0.211c-0.665-0.213-16.494-5.311-32.583-15.916 c-21.605-14.238-33.026-31.617-33.026-50.252V180.247h132.543v101.228c0,18.636-11.421,36.014-33.026,50.252 c-16.088,10.605-31.917,15.703-32.583,15.916L383.936,347.854z M322.034,184.617v96.858c0,39.281,55.178,59.469,61.902,61.782 c6.717-2.313,61.902-22.534,61.902-61.782v-96.858H322.034L322.034,184.617z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFj);
export default __webpack_public_path__ + "static/media/fj.867ebf53cb435d179d27f4e98fd1e545.svg";
export { ForwardRef as ReactComponent };